import React, { Component } from 'react';
import ReactGA from 'react-ga4';
import moment from 'moment';
import Login from './Login_new.jsx';
import PoPCampaign from './ProofOfPlayPostingLayout/PoPCampaign.jsx';
import PoDCampaign from './ProofOfDeliveryLayout/PoDCampaign.jsx';
import SiteNotAvailable from './SiteNotAvailable.jsx';
import ParameterService from '../services/parameterService.js';
import { checkAppVersion } from '../services/versionService.js';
import QueryStringService from '../services/queryStringService.js';
import HashParameterService from '../services/hashParameterService.js';
import OrderService from '../services/orderService.js';
import { ToastContainer } from 'react-toastify';

export default class Application extends Component {
    constructor() {
        super();
        this.parameterService = new ParameterService();
        this.hashParamService = new HashParameterService();
        this.state = {
            parameters: null,
            siteAvailable: true,
            loggedIn: false,
            orderData: null,
            customerId: null,
            inCampaignDetails: false,
            forceUsePop: false
        };

        this.handleHashChange = this.handleHashChange.bind(this);
        this.setForceUsePop = this.setForceUsePop.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        this.checkApplicationVersion();
        this.loadParameters();
        this.initializeAnalytics();
        window.addEventListener('hashchange', this.handleHashChange);

        // Set up periodic version checks
        this.versionCheckInterval = setInterval(() => {
            this.checkApplicationVersion();
        }, 10 * 60 * 1000); // Check every 10 minutes

    }

    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('hashchange', this.handleHashChange);

        // Clear version check interval
        if (this.versionCheckInterval) {
            clearInterval(this.versionCheckInterval);
        }
    }

    initializeAnalytics() {
        const hostString = window.location.hostname;
        const trackingID = hostString.includes('pop.clearchannel') ? 'UA-148423932-1' : 'UA-148423932-2';
        ReactGA.initialize(trackingID);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }

    handleHashChange() {
        const customerId = this.hashParamService.getParameter('advertiser');
        const orderId = this.hashParamService.getParameter('order');
        const orderlines = this.hashParamService.getParameter('orderlines');
        if (customerId && orderId) {
            this.login(customerId, orderId, orderlines);
        } else {
            this.setState({ loggedIn: false, orderData: null, customerId: null, inCampaignDetails: false });
        }
    }

    loadParameters() {
        this.parameterService.getParameters((paramData) => {
            if (this._isMounted && paramData) {
                this.setState({ parameters: paramData, siteAvailable: paramData.siteAvailable }, this.handleHashChange);
            }
        }, () => console.error('Error loading parameters'));
    }

    async checkApplicationVersion() {
        try {
            const versionChanged = await checkAppVersion();
            if (versionChanged && this._isMounted) {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error checking application version:', error);
        }
    }

    login(customerId, orderId, orderlines) {
        this.checkApplicationVersion().then(() => {
            const orderService = new OrderService();
            this.setState(prevState => ({
                orderData: null,
                loggedIn: false
            }));
            orderService.getOrder(customerId, orderId, (orderData) => {
                if (this._isMounted) {
                    if (!orderData || !orderData.orderLines.length) {
                        this.setState({ loggedIn: false, orderData: null, customerId, inCampaignDetails: false });
                    } else {
                        const replacementValueForlocalParam5 = new QueryStringService().getSearchParam("localparam5");
                        if (replacementValueForlocalParam5 !== null)
                            orderData.orderLines.map(p => p.localParameter5 = replacementValueForlocalParam5);

                        this.setState({
                            loggedIn: true,
                            orderData,
                            customerId,
                            inCampaignDetails: !!orderlines,
                        });
                    }
                }
            });
        });
    }

    handleLogin(orderData, customerId) {

        const replacementValueForlocalParam5 = new QueryStringService().getSearchParam("localparam5");
        if (replacementValueForlocalParam5 !== null)
            orderData.orderLines.map(p => p.localParameter5 = replacementValueForlocalParam5);


        this.setState({ loggedIn: true, orderData, customerId, inCampaignDetails: false });
        ReactGA.event({ category: 'User', action: 'Login' });
        this.hashParamService.updateParameter('advertiser', customerId);
        this.hashParamService.updateParameter('order', orderData.orderId);
    }

    handleLogout() {
        this.setState({ loggedIn: false, orderData: null, customerId: null, inCampaignDetails: false });
        window.location.hash = ''; // Clear URL hash on logout
    }

    renderCampaignComponent(showPoDCampaign) {
        const { orderData, customerId, parameters, forceUsePop } = this.state;
        const CampaignComponent = showPoDCampaign ? PoDCampaign : PoPCampaign;

        return (
            <>
                <CampaignComponent
                    onLogout={() => this.handleLogout()}
                    orderData={orderData}
                    customerId={customerId}
                    parameters={parameters}
                    forceUsePop={forceUsePop}
                    setForceUsePop={this.setForceUsePop}
                />
                <ToastContainer />
            </>
        );
    }

    getMaxPeriodStartDate(orderlines) {
        let maxDate = moment('1900-01-01');
        orderlines.forEach(obj => {
            let date = moment(obj.periodStart);
            if (date > maxDate) {
                maxDate = date;
            }
        });

        return maxDate;
    }

    setForceUsePop(value) {
        this.setState({ forceUsePop: value });
    };

    render() {
        const { parameters, siteAvailable, loggedIn, orderData, inCampaignDetails, forceUsePop } = this.state;

        if (parameters && !siteAvailable) return <SiteNotAvailable />;

        if (loggedIn) {
            const showPoDCampaign =
                !forceUsePop &&
                orderData &&
                orderData.orderLines.length > 0 &&
                this.getMaxPeriodStartDate(orderData.orderLines) >= moment(parameters.clientSettings.newLayoutForPodAfterOrderlineStartDate);

            return inCampaignDetails
                ? this.renderCampaignComponent(showPoDCampaign)
                : this.renderCampaignComponent(showPoDCampaign);
        }

        return parameters ? <Login onLogin={(orderData, customerId) => this.handleLogin(orderData, customerId)} /> : null;
    }
}
